module.exports = __webpack_public_path__ + "img/8.112b4611.png";